import React from 'react';
import { useLanguage } from '../common/LanguageContext';
import '../../styles/typography.css';
import '../../styles/components.css';

function LiftingMechanismDiagram() {
  const { translations } = useLanguage();
  const fileName = `${translations.designerPage.diagrams.liftingMechanism}.txt`;

  const handleDownload = () => {
    const element = document.createElement('a');
    const fileContent = `Content of file: ${translations.designerPage.diagrams.liftingMechanism}`; // Контент файла
    const file = new Blob([fileContent], { type: 'text/plain' });
    element.href = URL.createObjectURL(file);
    element.download = fileName;
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  return (
    <div className="download-link" onClick={handleDownload} style={{ cursor: 'pointer'}}>
      <h2 className="heading-secondary">{translations.designerPage.diagrams.liftingMechanism}</h2>
      <img src="lifting.png" alt="Lifting mechanism" className="diagram-image"
      />
    </div>
  );
}

export default LiftingMechanismDiagram;
